import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup , Validators, FormControl} from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { Observable, Subject } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';

import * as _moment from 'moment';
import { Moment} from 'moment';

import {ViewChildren, QueryList} from '@angular/core';
import {MatAutocompleteTrigger} from '@angular/material/autocomplete';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'educational',
  template: `
  <style>
  .mat-form-field--inline {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .mat-form-field--inline .mat-form-field {
        display: inline-block;
        width: 100%;
        vertical-align: middle;
    }

    .mat-form-field--inline .mat-form-field:nth-child(1) {
        margin-right: 10px;
    }
    
    @media (max-width: 767px) {
      #selectLine{  
        width: 65%;
      } 
    }
      
    @media (min-width: 1200px) {
      #selectLine{  
        width: 145%;
      } 
    }
      
    @media (min-width: 768px) {
      #selectLine{  
        width: 65%;
      } 

      .offset-md-3 {
        margin-left: 0%;
      }

      .col-md-6 {
          max-width: 100%;
      }

      #roll_no {
        left: 50px;
      }

      #semester_css{
        padding-left:45px;
      }
    }
      
    @media (min-width: 992px) {
      #selectLine{  
        width: 145%;
      } 

      #roll_no {
        left: 50px;
      }

      #semester_css{
        padding-left:45px;
      }
    }

    .example-full-width {
      width: 100%;
    }

    .popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Dimmed background */
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  z-index: 1000;
}

.popup {
  background: white;
  padding: 40px; /* Spacing around content */
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4); /* Stronger shadow */
  text-align: center;
  width: 800px; /* Width of the popup */
}

h2 {
  font-size: 2.4rem; /* Title font size */
  margin-bottom: 20px;
  font-weight: bold;
}

.popup-message {
  font-size: 1.5rem; /* Message font size */
  color: red; /* Text color */
  font-weight: bold; /* Bold text */
  line-height: 2; /* Line height for readability */
  margin-bottom: 30px;
}

.popup-actions {
  margin-top: 30px;
}

.ok-button {
  background-color: #4caf50; /* Green background for OK */
  color: white;
  padding: 15px 30px; /* Button size */
  font-size: 1.2rem; /* Button text size */
  border: none;
  border-radius: 6px; /* Rounded corners */
  cursor: pointer;
}

.ok-button:hover {
  background-color: #45a049; /* Slightly darker green on hover */
}
  </style>
  <nb-card status="success" class="col-md-6 offset-md-3" [style.height.px]="600">
    <nb-card-header>Add Your Last Appeared Exam Details</nb-card-header>
    <nb-card-body>
      <form [formGroup]="edu_form"  class="step-container"  [nbSpinner]="loading">
        <div class="row">
          <div class="col-md-3">Student type (विद्यार्थी प्रकार): </div>
          <div class="col-md-3">
            <mat-form-field>
              <mat-select [(ngModel)]="studType" [(value)]="studType" name="type" formControlName="studTypeCtrl"
                (selectionChange)="studentType($event)">
                <mat-option [value]="'External'">External</mat-option>
                <mat-option [value]="'Regular'">Regular</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
          <br>
        <div class="row">
          <div class="col-xl-3">College Name : (कॉलेजचे नाव) </div>
          <div class="col-xl-9">
            <div *ngIf="collegenameshow == false">
              <form class="example-form">
                <mat-form-field class="example-full-width">
                <input type="text"  (focus)="onFocus(0)"
                    placeholder="Select College"
                    aria-label="Number"
                    matInput
                    [formControl]="myControl"
                    [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete">
                  <mat-option (onSelectionChange)="selectCollegeBachelor($event, option.id ,'1' , option.college_name, option.College_address)" *ngFor="let option of filteredOptions | async" [value]="option.college_name">
                      {{option.college_name}}
                      </mat-option>
                  </mat-autocomplete>
                  </mat-form-field>
              </form>
              </div>
              <div *ngIf="collegenameshow == true">
                <input  formControlName="collegeNameCtrl" nbInput type="text"  readonly class="form-control">
                <a>
                  <i title="Edit College Name" class="fas fa-pen-fancy" (click)="editCollegeName()"></i>
                </a> 
              </div> 
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">College Address (कॉलेजचा पत्ता): </div>
          <div class="col-md-9"> <input  ngModel="{{edu_data?.CollegeAddress}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.collegeAddressCtrl.invalid && (edu_form.controls.collegeAddressCtrl.dirty || edu_form.controls.collegeAddressCtrl.touched)}" formControlName="collegeAddressCtrl" placeholder="Address" id="" class="form-control" readonly> </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-3">Course Name (अभ्यासक्रमाचे नाव): </div>
          <div class="col-md-9"> 
            <div *ngIf="coursenameshow == false">
              <form class="example-form">
                <mat-form-field class="example-full-width">
                <input type="text"  (focus)="onFocus(1)"
                    placeholder="Select Course Name"
                    aria-label="Number"
                    matInput
                    [formControl]="myControlCourse"
                    [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete">
                      <mat-option style="font-size:12px;" (onSelectionChange)="selectCourse($event, option.id ,'1' , option.course_name, option.duration,option.Course_subAdmin,option.part_name)" *ngFor="let option of filteredCourses" [value]="option.course_name">
                      {{option.course_name}} 
                      </mat-option>
                  </mat-autocomplete>
                  </mat-form-field>
              </form>
            </div>
              <input *ngIf="coursenameshow == true" formControlName="courseCtrl" nbInput type="text"  readonly class="form-control">
              <a>
                 <i title="Edit Course Name" class="fas fa-pen-fancy" (click)="editCourseName()"></i>
              </a>
          </div>
        </div>
        <br>
       
        <div class="row">
          <div class="col-md-3">Examination Pattern type (परीक्षेचा नमुना प्रकार): </div>
          <div class="col-md-3">
          <mat-form-field >
          <mat-select [(ngModel)]="pattern" [(value)]="pattern" name="pattern" formControlName="collegePatternCtrl" (selectionChange)="getData($event)">
              <mat-option [value]="'semester'">Semester</mat-option>
              <mat-option [value]="'annual'">Annual</mat-option>
          </mat-select>
          </mat-form-field>
          </div>
          <div class="col-md-3"  *ngIf="pattern=='annual'">
            Last attended year:(शेवटचे वर्ष) </div>
            <div class="col-md-3"  *ngIf="pattern=='annual'">
            <mat-form-field >
              <mat-select [(ngModel)]="pattern_year" (selectionChange)="onSelectPattern_year($event)" formControlName="collegeYearPatternCtrl">
              <mat-option  *ngFor = "let pattern_year of pattern_data_year" [value]="pattern_year" >{{pattern_year}}</mat-option>
              </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-3" *ngIf="pattern=='semester'">
            Last Attended Semester:   (शेवटचे सेमिस्टर)
            </div>
            <div class="col-md-3" *ngIf="pattern=='semester'">
            <mat-form-field>
              <mat-select [(ngModel)]="pattern_semester" (selectionChange)="onSelectPattern_sem($event)" formControlName="collegeSemPatternCtrl">
              <mat-option  *ngFor = "let pattern_semester of pattern_data_sem" [value]="pattern_semester" >{{pattern_semester}}</mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="semesterValidation===false" style="color:red;">Please select Semester.</span> 
    </div> 
        </div>
        <br>
     
      <br>
      <div class="row">
        <div class="col-md-3">Passing Month & Year (उत्तीर्ण महिना आणि वर्ष):</div>
        <div class="col-md-3">
          <mat-form-field appearance="fill">
            <mat-label>Month and Year</mat-label>
             <input matInput [matDatepicker]="dp" [formControl]="date" (focus)="dp.open()" readonly>
            <mat-datepicker-toggle matSuffix [for]="dp" (focus)="dp.open()"></mat-datepicker-toggle>
            <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event);onPassingYear($event)"
              (monthSelected)="chosenMonthHandler($event, dp)" panelClass="example-month-picker">
            </mat-datepicker>
          </mat-form-field>
          <span *ngIf="monthYearValidation===false" style="color:red;">Please select month and year.</span>
          <div class="form-group col-md-12" *ngIf="isYear">
            <span style="font-weight: bold; color: red;">If you are a pass-out student from 2004 to 2019, You need to apply offline by visiting the University. (जर तुम्ही 2004 ते 2019 दरम्यान सोलापूर युनिव्हर्सिटीमधून पास आहात, तर तुम्हाला युनिव्हर्सिटीला जाऊन ऑफलाइन अर्ज करावा लागेल.)</span>
          </div>
        </div>
        <div class="col-md-3" id="roll_no">Roll No/Seat No (रोल क्रमांक/आसन क्रमांक):</div>
        <div class="col-md-3">
          <input  ngModel="{{edu_data?.rollNo}}" nbInput type="text" pattern="[A-Za-z0-9]+" 
          (keypress)="OnlyNoCharAllowed($event)" [ngClass]="{'form-control-danger': edu_form.controls.rollNoCtrl.invalid && (edu_form.controls.rollNoCtrl.dirty || edu_form.controls.rollNoCtrl.touched)}" formControlName="rollNoCtrl" placeholder="Roll No" id="" class="form-control"> 
        </div>

        <div class="col-md-3">Result Status (निकाल स्थिती):</div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-select formControlName="resultCtrl" placeholder="Select Result">
              <mat-option *ngFor="let res of result_options" [value]="res">{{res}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span *ngIf="edu_form.controls.resultCtrl.invalid && (edu_form.controls.resultCtrl.dirty || edu_form.controls.resultCtrl.touched)" style="color:red;">Please select result status.</span>
        </div>

        <div class="col-md-3" id="roll_no"> PRN Number (कायमस्वरूपी नोंदणी क्रमांक):</div>
        <div class="col-md-3">
          <mat-form-field style="width:220px !important">
              <input  matInput ngModel="{{edu_data?.prn_no}}" (keyup)="onKeyPressPRN($event)" formControlName="input_prn" [ngClass]="{'form-control-danger': edu_form.controls['input_prn'].invalid && (edu_form.controls['input_prn'].dirty || edu_form.controls['input_prn'].touched)}">
          </mat-form-field>
          <br><span *ngIf="prnNoValidationError === true" style="color: red;">Only 6 or 16 digit numbers are allowed.</span>
      </div>


      </div>

    


      </form>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton hero status="primary" (click)="dismiss()">Close</button> 
        <button *ngIf="amount_paid == 'false' && !isYear" nbButton status="info" (click)="saveEdu()">save - क्लिक करण्यापूर्वी कृपया सर्व भरलेले तपशील पुन्हा तपासा

        </button>

        <!-- <button *ngIf="amount_paid == 'false' && showButton == true" nbButton status="info" (click)="saveEdu()">save</button> -->
    </nb-card-footer>
</nb-card>
<div class="popup-overlay" *ngIf="showPopup">
  <div class="popup">
    <h2>Confirmation</h2>
    <p class="popup-message">
      If you are a pass-out student from 2004 to 2019, You need to apply offline by visiting the University.
      <br />
      <strong>
        (जर तुम्ही 2004 ते 2019 दरम्यान सोलापूर युनिव्हर्सिटीमधून पास आहात, तर तुम्हाला युनिव्हर्सिटीला जाऊन ऑफलाइन अर्ज करावा लागेल.)
      </strong>
    </p>
    <div class="popup-actions">
      <button class="ok-button" (click)="onConfirm()">OK</button>
    </div>
  </div>
</div>
  `,
  providers: [
    ConfirmationService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class EducationalFormComponent implements OnInit {
  @ViewChildren(MatAutocompleteTrigger) autoComplete: QueryList<MatAutocompleteTrigger>;
  FeedbackForm : FormGroup;
  @Input() collegeAddress: any;
  @Input() collegeName: any;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() source: any;
  @Input() course: any;
  //@Input() course_name:string;
  @Input() amount_paid:string;
  @Input() admin_show:string;
  validations_flag = false;
  feedback_message ;
  showExperience = false;

  edu_form: FormGroup;
  filteredOptions: Observable<string[]>;
  filteredOptionCourses: Observable<string[]>;
  myControl = new FormControl('',Validators.required);
  myControlCourse = new FormControl('',Validators.required);
  years_array;
  courseValidation = true;
  collegeValidation = true;
  collegeYearValidation = true;
  semesterValidation  = true;
  monthValidation  = true;
  yearValidation = true;
  rollNOValidation = true;
  monthYearValidation = true;
  edu_data;
  course_data = [];
  college_data = [];
  user: any;
  collegenameshow = false;
  coursenameshow = false;
  collegename;
  college_address: any;
  college_info: any;
  loading: boolean;
  date = new FormControl(moment());
  pattern_data_year = ['First Year', 'Second Year', 'Third Year', 'Fourth Year', 'Fifth Year','Sixth Year'];
  pattern_data_sem = ['Sem I', 'Sem II', 'Sem III', 'Sem IV', 'Sem V', 'Sem VI', 'Sem VII', 'Sem VIII', 'Sem IX', 'Sem X', 'Sem XI', 'Sem XII'];
  result_options = ['Pass', 'Fail', 'Absent', 'Not Appeared', 'ATKT'];

  readonly numberpattern = /^[-+]?[0-9]+$/ ;
  readonly letterpattern =/^[A-Za-z]+$/;
  pattern: any;
  pattern_annual: boolean;
  pattern_semester: any;
  pattern_year: any;
  academicYear: string;
  duration: any;
  degree_type: any;
  partname: any;
  courseSubAdmin: any;
  college: any;
  // errorPopup: boolean;
  showButton: boolean = true;
  prnNoValidationError: boolean = false;
  errorPopup: boolean;
  paymentShow: boolean;
  collegeData : any[] = [];
  collegeId: any;
  selectedCollege: string;
  courseData: any[] = [];
  collegeCourse: any[] = [];
  filteredCourses: any[];
  courseId: any;
  selectedcourse : string
  studType: any;
  // paymentShow: boolean;
  // confirmationService: any;
  isYear: boolean = false;
  showPopup: boolean = false;

  constructor(protected api : ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<EducationalFormComponent>) { }

  async ngOnInit() {
    // this.getStudentEducation(this.user_id);
    this.edu_form = this.formBuilder.group({
      studTypeCtrl : [ '' ,  Validators.required],
      collegeNameCtrl : [ '' ,  Validators.required],
      collegeAddressCtrl : [ '',  Validators.required ],
      courseCtrl: [ '', Validators.required ],
      collegeYearPatternCtrl : [''],
      collegeSemPatternCtrl : [''],
      semesterCtrl : [ '' ],
      monthYearCtrl : [ '' ,  Validators.required],
      rollNoCtrl : [ '' ,  Validators.required],
      collegePatternCtrl : ['',Validators.required],
      resultCtrl : ['', Validators.required],
      input_prn  : ['',Validators.required]
      //overAllGradeCtrl : [ '' ,  Validators.required],
    })

    // if(this.course_name!=''){
    //   this.coursenameshow = true;
    //   this.edu_form.patchValue({
    //     courseNameCtrl : this.course_name,
    //   })
    // }
    this.getCourseslist()
    this.api.getColleges()
      .subscribe(
        (data: any) => {           
          if(data['status'] == 200){
            this.collegeData = data['data'].college
            this.collegeCourse = data['data'].college_course
            // data['colleges'].forEach((element)=>{
            //   this.college_data.push( element ) 
            // })
          }else{

          }
    });

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    
    this.filteredOptionCourses = this.myControlCourse.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCourse(value))
    );


    const now = new Date().getUTCFullYear();    
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
    if(this.user_id != null){
      this.api.getEducation(this.edu_id,this.user_id)
      .subscribe(
        (data: any) => { 
          if(data['status'] == 200){
            this.edu_data = data['data'];
            this.onPassingYear(this.edu_data.Year);
            this.date = new FormControl(moment(this.edu_data.Month));
            this.edu_form.patchValue({
              monthYearCtrl :this.date.value,
            })
            if(data['data']['result']){
              this.edu_form.patchValue({
                resultCtrl : data['data']['result'],
              })
            }
            if(data['data']['CollegeName']){
              this.edu_form.controls.collegeNameCtrl.setValidators([]);
              this.edu_form.controls.collegeNameCtrl.updateValueAndValidity();
              this.collegenameshow = true;
              this.edu_form.patchValue({
                collegeNameCtrl :data['data']['CollegeName'],
              })
              if(data['data']['CollegeName']){
                this.getCourseslist();
              }
            }
            if(data['data']['CourseName']){
              this.edu_form.controls.courseCtrl.setValidators([]);
              this.edu_form.controls.courseCtrl.updateValueAndValidity();
              this.coursenameshow = true;
              this.edu_form.patchValue({
                courseCtrl :data['data']['CourseName'],
              })
            }
            if(data['data']['pattern']){
              this.edu_form.controls.collegePatternCtrl.setValidators([]);
              this.edu_form.controls.collegePatternCtrl.updateValueAndValidity();
              this.pattern = data['data']['pattern']
            }
            if(data['data']['student_type']){
              this.edu_form.controls.studTypeCtrl.setValidators([]);
              this.edu_form.controls.studTypeCtrl.updateValueAndValidity();
              this.studType = data['data']['student_type']
            }
            if(data['data']['duration']){
            this.duration = data['data']['duration'];
            var duration_year = this.duration;
            var duratio_sem = 2*this.duration;
            this.pattern_data_year = this.pattern_data_year.splice(0,duration_year);
            this.pattern_data_sem = this.pattern_data_sem.splice(0,duratio_sem);
            }
            
            if(data['data']['Semester']){
              this.edu_form.controls.collegeSemPatternCtrl.setValidators([]);
              this.edu_form.controls.collegeSemPatternCtrl.updateValueAndValidity();
              this.pattern_semester = data['data']['Semester'];
              if(data['data']['Semester'] && this.pattern == 'semester'){
                this.api.getCourseDetails(this.edu_form.controls.courseCtrl.value,data['data']['Semester'],this.edu_form.controls.collegeNameCtrl.value).subscribe(
                  (course:any)=>{
                    
                    this.partname = course.data ? (course.data.part_name ? course.data.part_name : '') : '';

                    this.courseSubAdmin = course.data ? (course.data.Course_subAdmin ? course.data.Course_subAdmin : '') : '';       
                  }

        )
              }
            }
            if(data['data']['CollegeYear'] && this.pattern == 'annual'){
              this.edu_form.controls.collegeYearPatternCtrl.setValidators([]);
              this.edu_form.controls.collegeYearPatternCtrl.updateValueAndValidity();
              this.pattern_year = data['data']['CollegeYear'];
              if(data['data']['CollegeYear']){
                this.api.getCourseDetails(this.edu_form.controls.courseCtrl.value,data['data']['CollegeYear'],data['data']['CollegeName']).subscribe(
                  (course:any)=>{
                    
                    this.partname = course.data ? (course.data.part_name ? course.data.part_name : '') : '';

                    this.courseSubAdmin = course.data ? (course.data.Course_subAdmin ? course.data.Course_subAdmin : '') : '';
                  }
                )
              }
            }
          }else{
          }
      });
    }
  }


  onKeyPressPRN(event: any) {
		if(this.edu_form.controls.input_prn.value.length>16||this.edu_form.controls.input_prn.value.length<6){
		
			this.prnNoValidationError=true
		 }else{
			 this.prnNoValidationError=false
		 }
		
	 };

  private _filter(value: string){
    const filterValue = this._normalizeValue(value);
  
    // return this.college_data.filter(option => this._normalizeValue(option.college_short_form).includes(filterValue)); 
    return this.collegeData.filter(option => this._normalizeValue(option.college_name).includes(filterValue)); 

  }

  private _filterCourse(value: string){
    const filterValue = this._normalizeValue(value);
  
    return this.filteredCourses.filter(option => this._normalizeValue(option.course_name).includes(filterValue)); 
  }
  
  private _normalizeValue(value: string): string {
    if(value){
      return value.toLowerCase().replace(/\s/g, '');
    }else{
      return '';
    }
  }

//   getStudentEducation(user_id){ 
// this.loading = true
//     this.api.getStudentCollegeData(this.user_id).subscribe(data => { 
//       if(data['status']==200){
//         this.college_info = data['data'];
//         if(this.college_info.CollegeName !=null){
//           this.edu_form.controls.collegeNameCtrl.setValidators([]);
//           this.edu_form.controls.collegeNameCtrl.updateValueAndValidity();
//           this.collegenameshow = true;
//           if(this.college_info.CourseName == null || this.college_info.CourseName == 'null'){
//           this.coursenameshow = false;
//           }else{
//           this.coursenameshow = true;
//           }
//           this.edu_form.patchValue({
//            collegeNameCtrl:  this.college_info.CollegeName
//           })
//           this.date = new FormControl(moment(this.college_info.Year));
//           this.edu_form.patchValue({
//             monthYearCtrl :this.date.value,
//           })
//            this.api.getCourses(this.course,this.college_info.CollegeName)
//                   .subscribe(
//                 (data: any) => {
//                 if(data['status'] == 200){
//                 this.course_data = [];
//                 data['data'].forEach((element)=>{
//             this.course_data.push( element ) ;
//           })
//         }else{

//         }
//     });
//         }
//         if(this.college_info.CollegeAddress !=null){
//           this.edu_form.controls.collegeAddressCtrl.setValidators([]);
//           this.edu_form.controls.collegeAddressCtrl.updateValueAndValidity();
//         //  this.edu_form.controls.collegeAddressCtrl.setValue(this.college_info.collegeName)
//         this.collegenameshow = true;
//         if(this.college_info.CourseName == null){
//           this.coursenameshow = false;
//         }else{
//           this.coursenameshow = true;
//         }
//       this.edu_form.patchValue({
//         collegeAddressCtrl : this.college_info.CollegeAddress
//     })
//   } this.loading = false;
//       }else if(data['status']==401){
//         this.loading = false
//       }
//     })
    
//   }

  saveEdu() {
    // this.api.checkDuplicate(name,this.user_id,this.college)
    // .subscribe(
    //   (data: any) => {  
    //   if(data['data']==false){
    //     this.showButton = data['data'];
    //     this.errorPopup=true;
    //     if(this.showButton == false){
    //       this.confirmationService.confirm({
    //         message: 'We have same application in our database with same details',
    //         header: 'Duplicate Id',
    //         icon: 'pi pi-info-circle',
    //         rejectVisible : false,
    //         acceptLabel: 'Ok',              
    //         accept: () => {
    //           this.router.navigate(['auth/logout'])
    //         }
    //         });
    //     }
    //   }
    // });
    // this.edu_form.controls.rollNoCtrl.setValidators([ Validators.required, Validators.pattern(this.numberpattern)]);
    // this.edu_form.controls.rollNoCtrl.updateValueAndValidity();
    //this.edu_form.controls.overAllGradeCtrl.setValidators([ Validators.required, Validators.pattern(this.letterpattern)]);
    //this.edu_form.controls.overAllGradeCtrl.updateValueAndValidity();
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.semesterValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.rollNOValidation = true;
    this.monthYearValidation = true;
    var error=this.findInvalidControls(this.edu_form.controls);

    if(this.user_id != null){
      if (this.edu_form.valid==false){
        this.edu_form.controls.collegeNameCtrl.markAsDirty();
        this.edu_form.controls.collegeAddressCtrl.markAsDirty();
        this.edu_form.controls.courseCtrl.markAsDirty();
        //this.edu_form.controls.overAllGradeCtrl.markAsDirty();
        this.edu_form.controls.rollNoCtrl.markAsDirty();
        // this.edu_form.controls.partNameCtrl.markAsDirty();
        this.edu_form.controls.studTypeCtrl.markAsDirty();
        this.edu_form.controls.resultCtrl.markAsDirty();

          if(this.edu_form.controls.courseCtrl.value === null || this.edu_form.controls.courseCtrl.value ==='' || this.edu_form.controls.courseCtrl.value ===undefined){
            this.courseValidation = false;
          }else {
            this.courseValidation = true;
          }
    
          // if(this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value ==='' || this.edu_form.controls.semesterCtrl.value ===undefined){
          //   this.semesterValidation = false;
          // }else {
          //   this.semesterValidation = true;
          // }
  
          if(this.edu_form.controls.monthYearCtrl.value === null || this.edu_form.controls.monthYearCtrl.value ==='' || this.edu_form.controls.monthYearCtrl.value ===undefined){
            this.monthYearValidation = false;
          }else {
            this.monthYearValidation = true;
          }
    
          // if(this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value ==='' || this.edu_form.controls.monthCtrl.value ===undefined){
          //   this.monthValidation = false;
          // }else {
          //   this.monthValidation = true;
          // }
    
          // if(this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value ==='' || this.edu_form.controls.yearCtrl.value ===undefined){
          //   this.yearValidation = false;
          // }else {
          //   this.yearValidation = true;
          // }
  
          if(this.edu_form.controls.rollNoCtrl.invalid && (this.edu_form.controls.rollNoCtrl.dirty || this.edu_form.controls.rollNoCtrl.touched)){
            this.rollNOValidation = false;
          }else{
            this.rollNOValidation = true;
          }     
   

      
      }else{
          // if(this.edu_form.controls.studTypeCtrl.value == 'External'){
            var edu_data = {
              collegeName: this.edu_form.controls.collegeNameCtrl.value,
              collegeAddress: this.edu_form.controls.collegeAddressCtrl.value,
              courseName: this.edu_form.controls.courseCtrl.value,
              collegeYear: this.academicYear ? this.academicYear : this.pattern_year,
              semester: this.pattern_semester,
              month: this.edu_form.controls.monthYearCtrl.value,
              rollNo: this.edu_form.controls.rollNoCtrl.value,
              user_id: this.user_id,
              id: this.edu_id,
              pattern: this.pattern,
              duration: this.duration,
              degree_type: this.degree_type,
              partname: this.partname,
              courseSubAdmin: this.courseSubAdmin,
              prn_no: this.edu_form.controls.input_prn.value,
              result: this.edu_form.controls.resultCtrl.value,
              courseId: this.courseId,
              collegeId: this.collegeId,
              studentType: this.edu_form.controls.studTypeCtrl.value,
            }

            this.api.setEducationalValues(edu_data)
              .subscribe(
                (data: any) => {
                  this.ref.close(data);
                  err => console.error(err)
                });
          // }
      }
    }else{
      alert("There is problem in saving data please login with your credentials and add further details.")
    }
  }

  dismiss() {
    this.ref.close();
  }

  selectCollegeBachelor(event, college , value, name, college_address){
    this.selectedCollege = event.source.value
    const selectedCollegeEntry = this.collegeData.find(college => college.college_name === this.selectedCollege);
      this.collegeId  = selectedCollegeEntry.id
      const filteredCollegeCourses = this.collegeCourse.filter(course => course.college_id === this.collegeId);
      const courseIds = filteredCollegeCourses.map(course => course.course_id);
      this.filteredCourses =this.courseData.filter(course => courseIds.includes(course.id));
    
    if (event.isUserInput) { 
      this.myControl.setValidators([ ]);
      this.myControl.updateValueAndValidity();
      this.edu_form.patchValue({
        collegeNameCtrl :name,
      })
      this.edu_form.patchValue({
        collegeAddressCtrl :college_address,
      })

      this.myControlCourse.reset();
      this.myControlCourse.updateValueAndValidity();
      this.coursenameshow = false;
      this.edu_form.patchValue({
        courseCtrl :'',
      })


      this.getCourseslist();
    }
  }

  getCourseslist(){
    this.course_data = [];
    this.api.getCourses()
    .subscribe(
      (data: any) => { 
        if(data['status'] == 200){
          // this.course_data = [];
          // data['data'].forEach((element)=>{           
          //   this.course_data.push( element ) 
          // })
          this.courseData  =data['data']
          
        }else{

        }
    });
  }

  selectCourse(event, college , value, name, part_name, courseSubAdmin,partname ){
    this.selectedcourse = event.source.value;
    const selectedCourseEntry = this.courseData.find(course => course.course_name === this.selectedcourse);
      this.courseId  = selectedCourseEntry.id
      
    if (event.isUserInput) { 
      // this.api.checkDuplicate(name,this.user_id,this.college)
      // .subscribe(
      //   (data: any) => {  
      //   if(data['data']==false){
      //     this.showButton = data['data'];
      //     this.errorPopup=true;
      //     if(this.showButton == false){        
      //       this.confirmationService.confirm({
      //         message: 'We have same application in our database with same details',
      //         header: 'Duplicate Id',
      //         icon: 'pi pi-info-circle',
      //         rejectVisible : false,
      //         acceptLabel: 'Ok',              
      //         accept: () => {
      //           this.router.navigate(['auth/logout'])
      //         }
      //         });
      //     }
      //   }
      // });
    
  
    
    
      this.myControlCourse.setValidators([ ]);
      this.myControlCourse.updateValueAndValidity();
      this.pattern_data_sem = ['Sem I', 'Sem II', 'Sem III', 'Sem IV', 'Sem V', 'Sem VI', 'Sem VII', 'Sem VIII', 'Sem IX', 'Sem X', 'Sem XI', 'Sem XII'];
      this.pattern_data_year = ['First Year', 'Second Year', 'Third Year', 'Fourth Year', 'Fifth Year','Sixth Year'];
      this.duration = part_name;
      this.courseSubAdmin = courseSubAdmin
      this.partname =part_name
      this.partname =partname

      var duration_year = this.duration;
      var duration_sem = 2*this.duration;
      this.pattern_data_year = this.pattern_data_year.splice(0,duration_year);
      this.pattern_data_sem = this.pattern_data_sem.splice(0,duration_sem);
      // this.degree_type = term_name ? term_name : null;
      this.edu_form.patchValue({
        courseCtrl : name,
      })
      //

    }
}

  public findInvalidControls(controls) {
    const invalid = [];

    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }

  // MatAutocompleteTrigger 
  editCollegeName(){
    this.edu_form.controls.collegeNameCtrl.setValidators([Validators.required]);
    this.edu_form.controls.collegeNameCtrl.updateValueAndValidity();
    this.collegenameshow = false;
    this.edu_form.patchValue({
      collegeNameCtrl :'',
    })
    this.edu_form.patchValue({
      collegeAddressCtrl :'',
    })
    this.editCourseName();
  }

  editCourseName(){
    // this.course_data = [];
    // if(this.edu_data){
    //   
    //   this.getCourseslist(this.edu_data.CollegeName);
    // }
    this.edu_form.controls.courseCtrl.setValidators([Validators.required]);
    this.edu_form.controls.courseCtrl.updateValueAndValidity();
    // this.edu_form.controls.collegePatternCtrl.setValidators([Validators.required]);
    // this.edu_form.controls.collegePatternCtrl.updateValueAndValidity();
    this.coursenameshow = false;
    this.edu_form.patchValue({
      courseCtrl :'',
    })
    // this.edu_form.patchValue({
    //   partNameCtrl :'',
    // })
    // this.edu_form.patchValue({
    //   semesterCtrl :'',
    // })
    // this.edu_form.patchValue({
    //   collegeYearCtrl :'',
    // })
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.edu_form.patchValue({
      monthYearCtrl :this.date.value,
    })
  }

  onFocus(value){
    this.autoComplete['_results'][value]._onChange('');
    this.autoComplete['_results'][value].openPanel();
    }

    OnlyNoCharAllowed(event): boolean {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 90) {
        return false;
      }
      return true;
      }

      getData(pattern){
        this.pattern = pattern.source.value;
        if(pattern.value == 'semester'){
          // this.pattern_data_sem = this.patternData.term_name;
          this.edu_form.controls.collegeSemPatternCtrl.setValidators([Validators.required]);
          this.edu_form.controls.collegeSemPatternCtrl.updateValueAndValidity();
          this.edu_form.controls.collegeYearPatternCtrl.clearValidators();
          this.edu_form.controls.collegeYearPatternCtrl.updateValueAndValidity();
          this.pattern_annual = true;
        }else if(pattern.value == 'annual'){
          // this.pattern_data_year = this.patternData.year;       
          this.edu_form.controls.collegeSemPatternCtrl.clearValidators(); 
          this.edu_form.controls.collegeSemPatternCtrl.updateValueAndValidity();     
          this.edu_form.controls.collegeYearPatternCtrl.setValidators([Validators.required]);
          this.edu_form.controls.collegeYearPatternCtrl.updateValueAndValidity();
          this.pattern_annual = false;
          this.pattern_semester = null;
        }//
        
      }

      onSelectPattern_year(year){
        this.pattern_year = year.value;
        if(this.pattern_year == 'Sem I' || this.pattern_year == 'Sem II' ){
          this.academicYear = 'First Year';
        }else if(this.pattern_year == 'Sem III' || this.pattern_year == 'Sem IV'){
          this.academicYear = 'Second Year';
        }else if(this.pattern_year == 'Sem V' || this.pattern_year == 'Sem VI'){
          this.academicYear = 'Third Year';
        }else if(this.pattern_year == 'Sem VII' || this.pattern_year == 'Sem VIII'){
          this.academicYear = 'Fourth Year';
        }else if(this.pattern_year == 'Sem IX' || this.pattern_year == 'Sem X'){
          this.academicYear = 'Fifth Year';
        }else if(this.pattern_year == 'Sem XI' || this.pattern_year == 'Sem XII'){
          this.academicYear = 'Sixth Year';
        }
        this.api.getCourseDetails(this.edu_form.controls.courseCtrl.value,year.value,this.edu_form.controls.collegeNameCtrl.value).subscribe(
          (course:any)=>{
            if(course['status'] == 200){
              
              this.partname = course.data ? (course.data.part_name ? course.data.part_name : '') : '';

              this.courseSubAdmin = course.data ? (course.data.Course_subAdmin ? course.data.Course_subAdmin : '') : '';
            }
          }

        )
      }

      onSelectPattern_sem(pattern_sem){
        this.pattern_semester = pattern_sem.value;
        if(this.pattern_semester == 'Sem I' || this.pattern_semester == 'Sem II' ){
          this.academicYear = 'First Year';
        }else if(this.pattern_semester == 'Sem III' || this.pattern_semester == 'Sem IV'){
          this.academicYear = 'Second Year';
        }else if(this.pattern_semester == 'Sem V' || this.pattern_semester == 'Sem VI'){
          this.academicYear = 'Third Year';
        }else if(this.pattern_semester == 'Sem VII' || this.pattern_semester == 'Sem VIII'){
          this.academicYear = 'Fourth Year';
        }else if(this.pattern_semester == 'Sem IX' || this.pattern_semester == 'Sem X'){
          this.academicYear = 'Fifth Year';
        }else if(this.pattern_semester == 'Sem XI' || this.pattern_semester == 'Sem XII'){
          this.academicYear = 'Sixth Year';
        }
        this.api.getCourseDetails(this.edu_form.controls.courseCtrl.value, pattern_sem.value, this.edu_form.controls.collegeNameCtrl.value).subscribe(
          (course:any)=>{
            
            this.partname = course.data ? (course.data.part_name ? course.data.part_name : '') : '';

            this.courseSubAdmin =  course.data ? (course.data.Course_subAdmin ? course.data.Course_subAdmin : '') : '';
             
          }

        )
      }

      studentType(event){
        if(event.value == 'Regular'){
          // console.log('insideeeeeeeeeeee ifffffffffffffffff');
          
          // this.confirmationService.confirm({
          //   message: 'Transfer Certificate is not for Regular students',
          //   acceptLabel: "OK",
          //   rejectVisible: false,
          //   accept: () => {
          //     this.router.navigate(['auth/logout']);
          //   }
          // })
        }else{
        }
      }
      
      onPassingYear(event: Moment){
        const monthYearCtrl = this.edu_form.controls.monthYearCtrl.value != '' ? moment(this.edu_form.controls.monthYearCtrl.value) : moment(event); // Example Moment object
        const year = monthYearCtrl.year();
        
        if(year >= 2004 && year <= 2019){
          this.isYear = true;
          this.showPopup = true; // Show the popup
        }else{
          this.isYear = false;
          this.showPopup = false;
        }
      }

      onConfirm() {
        this.router.navigate(['/pages/dashboard']);
        this.showPopup = false;
        this.ref.close();
      }
}
